import Select from './Select'

import './style.scss'

export { Select }
export default Select
